import React, { memo, useMemo } from 'react';

import { usePin } from 'react/hooks/sidebar.hook';
import SingleMenuItem from './SingleMenuItem';
import { getShortedRecentMenus, navigateToUrl } from './utils';

function PinnedMenus() {
  const { pinnedMenus } = usePin();

  const parsedRecentItems = useMemo(() => getShortedRecentMenus(pinnedMenus), [pinnedMenus]);

  return (
    <div data-testid="sidebar-pinneds-container" className="pinneds-container">
      <ul>
        {parsedRecentItems.map((item, i) => (
          <div key={i}>
            <span 
              onClick={() => navigateToUrl(item.url)}
              className="name-abbreviation"
            >
              {item.abbreviation}
            </span>
            <SingleMenuItem 
              external={item.external}
              url={item.url}
              name={item.name}
              panel={item.panel}
            />
          </div>
        ))}
      </ul>
    </div>
  );
}

export default memo(PinnedMenus);